export const MAX_ACTIVITY_TAG_NAME_LENGTH = 255

const SLUG_REGEX = /^[a-z][a-z-]+[a-z]$/

function deriveSlug(name: string): string {
  return name
    .replace(/ /g, '-')
    .replace(/[^a-zA-Z-]/g, '')
    .toLowerCase()
}

export function isActivityTagNameInvalid(trimmedName: string): boolean {
  if (trimmedName.length === 0) return false

  return !SLUG_REGEX.test(deriveSlug(trimmedName))
}
